module.exports = __webpack_public_path__ + "static/img/3.539b849.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/2/zh/3.png
// module id = KDJb
// module chunks = 0